import { submitStripePaymentForm, confirmStripePayment } from './Stripe/actions';
import { initiateVoucherPayment } from './Voucher/actions';

export const INIT_PAYMENT_METHOD = 'INIT_PAYMENT_METHOD';

export const initPaymentMethod = (paymentMethod, paymentMethodData) => ({
	type: INIT_PAYMENT_METHOD,
	payload: {
		paymentMethodName: paymentMethod.name,
		paymentMethodData
	}
});

export const initiatePaymentWithMethod = (paymentMethod) => (dispatch, getState) => {
	if (paymentMethod) {
		switch (paymentMethod.name) {
			case 'Stripe':
				return dispatch(submitStripePaymentForm(paymentMethod));
			case 'Voucher':
				return dispatch(initiateVoucherPayment(paymentMethod));
		}
	}
	return Promise.resolve();
};

export const confirmPaymentWithMethod = (paymentMethod, authorizationToken, returnUrl) => (dispatch, getState) => {
	if (paymentMethod) {
		switch (paymentMethod.name) {
			case 'Stripe':
				return dispatch(confirmStripePayment(paymentMethod, authorizationToken, returnUrl));

		}
	}
	return Promise.resolve();
};